export { CollapsibleSplitter } from './collapsible-splitter';
